<template>
  <div>
    <el-dialog
      :visible.sync="show"
      width="674px"
      title="输入资产密码"
      :show-close="true"
    >
      <div class="cell">
        <el-input
          placeholder="请输入密码"
          v-model="password"
          show-password
        ></el-input>
        <div class="page_btn_cell">
          <el-button class="btn" @click="close">取消</el-button>
          <el-button class="btn blue" type="primary" @click="submit">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "WalletPassword",
  data() {
    return {
      show: false,
      password: "",
    };
  },
  created() {},
  props: {},
  methods: {
    open() {
      this.password = "";
      this.show = true;
    },
    close() {
      this.show = false;
    },
    submit() {
      this.$emit("submit", this.password);
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.page_btn_cell{
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  .btn{
    width: 150px;
    margin-left: 10px;
  }
  .blue{
    background: #2f75fb;
  }
}
</style>
